export default {
  atDepth: '{valueUnit} bei {depth} {depthUnit}',
  time: 'Zeit',
  temp: 'Temp.',
  nlPerHPerM: 'Durchfluss',
  cAtm: 'Atmosphäre',
  cnAtm: 'Atmosphäre',
  cd: 'cd',
  retainedAustenite: 'ret. aust. ca.',
  hardnessProfile: 'Härte',
  modal: {
    header: 'Konfiguration der Kohlenstofftabelle',
    depth: 'Tiefe',
  },
};
